import { Button, Col } from "antd";
import { ReactNode } from "react";
import { EntityManager } from "../../components/entityManager";
import { enmControlType, enmPropertyType, IMetadata } from "../../components/entityManager/interfaces";
import { InsurerCenter } from "../insurerCenter";
import { enmInsurerCenterTypes } from "../insurerCenter/interfaces";
import { UserRelation } from "../userRelation";
import { IInsurer, IInsurerProps, IInsurerStates } from "./interfaces";

export class Insurer extends EntityManager<IInsurer, IInsurerProps, IInsurerStates> {
    static initMetadata = (): IMetadata => {
        return {
            name: "Insurer",
            title: "بیمه گر",
            Properties: [
                {
                    title: "نام",
                    dataIndex: "Name",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام شرکت بیمه گر را وارد نمایید' }]
                },
                {
                    title: "نام لاتین",
                    dataIndex: "NameEn",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    rules: [{ required: true, message: 'لطفا نام لاتین را وارد نمایید' }],
                    showInLookup: false
                },
                {
                    title: "نام مدیرعامل",
                    dataIndex: "CeoName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showInLookup: false
                },
                {
                    title: "آدرس",
                    dataIndex: "Address",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "تلفن",
                    dataIndex: "Phone",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "نمابر",
                    dataIndex: "Fax",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "نام رابط",
                    dataIndex: "ContactName",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "همراه رابط",
                    dataIndex: "ContactMobile",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                },
                {
                    title: "سمت رابط",
                    dataIndex: "ContactPosition",
                    propertyType: enmPropertyType.string,
                    controlType: enmControlType.textbox,
                    filterable: true,
                    width: 150,
                    showColumn: false,
                    showInLookup: false
                }
            ]
        };
    }

    onInitializing() {
        this.searchArea = { columnsPerRow: 2 };
        this.searchable = true;

        this.renderingToolbar = () => {
            let insurerCenterAccess = this.initialData?.AccessList["InsurerCenter"];
            let userInsurerAccess = this.initialData?.AccessList["UserInsurer"];

            let result: ReactNode[] = [];
            if (userInsurerAccess === true) {
                result.push(
                    <Col key="Users" style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={this.onUsersClick}>کاربران</Button>
                    </Col>
                );
            }
            if (insurerCenterAccess === true) {
                result.push(
                    <Col key="Branches" style={{ marginLeft: 10 }}>
                        <Button type="default" onClick={this.onBranchesClick}>مناطق</Button>
                    </Col>
                );
            }

            return result.length ? (<> {result} </>) : (<></>);
        };
    }
    onBranchesClick = () => {
        this.addLookupForm("InsurerCenter",
            <InsurerCenter
                key="InsurerCenter"
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                params={() => {
                    return { insurer: this.selectedEntity, type: enmInsurerCenterTypes.Zone }
                }}
            />);
    }
    onUsersClick = () => {
        this.addLookupForm("UserInsurer",
            <UserRelation
                key="UserInsurer"
                title="کاربران بیمه گر"
                metadataName="UserInsurer"
                invokePath={this.metadata.title}
                isChildComponent={true}
                onClose={this.onLookupClosed}
                params={() => {
                    return { sourceId: this.selectedEntity?.Id, description: this.selectedEntity?.Name ?? "" }
                }}
            />);
    }
}